<template>
  <div
    v-if="filterIsActive"
    class="filter-details"
  >
    <ul class="filter-details__list">
      <li class="filter-details__entry">
        <span v-t="'c.contentFilterDetails.label.tags'"/>
        <span>{{ tags }}</span>
      </li>
      <li class="filter-details__entry">
        <span v-t="'c.contentFilterDetails.label.createdAt'"/>
        <span>
          {{ createdAt }}
        </span>
      </li>
      <li class="filter-details__entry">
        <span v-t="'c.contentFilterDetails.label.publishedAt'"/>
        <span>
          {{ publishedAt }}
        </span>
      </li>
    </ul>
    <ul class="filter-details__list">
      <li class="filter-details__entry">
        <span v-t="'c.contentFilterDetails.label.priority'"/>
        <span>{{ priority }}</span>
      </li>
      <li class="filter-details__entry">
        <span v-t="'c.contentFilterDetails.label.source'"/>
        <span>{{ sourceInfo }}</span>
      </li>
      <li class="filter-details__entry">
        <span v-t="'c.contentFilterDetails.label.countries'"/>
        <span>{{ countries }}</span>
      </li>
    </ul>

    <button
      v-if="resetEnabled"
      @click="reset"
    >
      <font-awesome-icon icon="trash" />
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import isBlank from 'is-blank'
import fullDate from '@/filters/fullDate'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    resetEnabled: {
      type: Boolean,
      default: () => false
    },
  },
  computed: {
    ...mapState({
      filter: state => state.contentFilter.filter,
    }),
    ...mapGetters({
      filterIsActive: 'contentFilter/filterIsActive'
    }),
    tags () {
      return isBlank(this.filter.tags) ? '-' : this.filter.tags.join(', ')
    },
    createdAt () {
      const key = isBlank(this.filter.createdAtFrom) + '' + isBlank(this.filter.createdAtUntil)

      switch (key) {
        case 'falsefalse':
          return fullDate(this.filter.createdAtFrom) + ' - ' + fullDate(this.filter.createdAtUntil)
        case 'falsetrue':
          return 'ab ' + fullDate(this.filter.createdAtFrom)
        case 'truefalse':
          return 'bis ' + fullDate(this.filter.createdAtUntil)
        default:
          return '-'
      }
    },
    publishedAt () {
      const key = isBlank(this.filter.publishedAtFrom) + '' + isBlank(this.filter.publishedAtUntil)

      switch (key) {
        case 'falsefalse':
          return fullDate(this.filter.publishedAtFrom) + ' - ' + fullDate(this.filter.publishedAtUntil)
        case 'falsetrue':
          return 'ab ' + fullDate(this.filter.publishedAtFrom)
        case 'truefalse':
          return 'bis ' + fullDate(this.filter.publishedAtUntil)
        default:
          return '-'
      }
    },
    priority () {
      return isBlank(this.filter.priority) ? '-' : this.filter.priority
    },
    countries () {
      return isBlank(this.filter.countries) ? '-' : this.filter.countries.map(({ label }) => (label)).join(', ')
    },
    sourceInfo () {
      const external = this.$t(`c.contentFilterForm.form.options.${this.filter.external}`)

      return isBlank(this.filter.external) && isBlank(this.filter.sourceName)
        ? '-'
        : [this.filter.sourceName, external].filter(n => n).join(' / ')
    }
  },
  methods: {
    reset () {
      this.$emit('resetFilter')
    }
  }
}
</script>

<style lang="sass">
.filter-details
  position: relative
  display: flex
  justify-content: space-between
  border: 1px solid #ccc
  padding: 5px 45px 5px 20px
  font-size: 14px
  margin-top: 30px
  margin-bottom: 15px
  border-radius: 3px

  button
    position: absolute
    top: 8px
    right: 8px
    width: 25px
    height: 25px

  &__list
    width: 48%

  &__entry
    display: flex
    justify-content: space-between
    padding: 8px 0

.filter-details__entry + .filter-details__entry
  border-top: 1px dotted #ccc

</style>




// WEBPACK FOOTER //
// src/components/contents/ContentFilterDetails.vue